(function () {
  const CFG = window.CL_POPUP_CONFIG;
  const SRC_W = 1600, SRC_H = 1200;
  const LS = { sub: 'clp_hd_subscribed_v1', dis: 'clp_hd_dismissed_at_v1' };

  const root   = document.getElementById('clp-root');
  const pop    = root.querySelector('.clp-pop');
  const stage  = root.querySelector('.clp-stage');
  const scene  = root.querySelector('.clp-scene');
  const canvas = root.querySelector('.clp-scratch');
  const ctx    = canvas.getContext('2d');
  const hint   = root.querySelector('.clp-hint');
  const form   = root.querySelector('.clp-form');
  const input  = root.querySelector('#clp-email');
  const errEl  = root.querySelector('.clp-err');
  const status = root.querySelector('.clp-status');
  const bar    = root.querySelector('.clp-progress i');
  const revealBtn = root.querySelector('[data-reveal-now]');
  const chips  = root.querySelector('.clp-chips');
  const grid   = root.querySelector('.clp-grid');
  const sheetTitle = root.querySelector('.clp-sheet-title');
  const sheetSub   = root.querySelector('.clp-sheet-sub');
  const viewAll    = root.querySelector('.clp-viewall');

  const isDemoKlaviyo = !CFG.klaviyo.companyId || CFG.klaviyo.companyId.startsWith('YOUR_');
  const demoModeEl = document.getElementById('demo-mode');
  if (demoModeEl) demoModeEl.textContent = isDemoKlaviyo ? 'demo mode' : 'live mode';

  /* ---------- storage helpers (never let storage errors break the popup) ---------- */
  const store = {
    get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } },
    set(k,v){ try { localStorage.setItem(k,v); } catch(e){} },
    del(k){ try { localStorage.removeItem(k); } catch(e){} }
  };

  /* ---------- analytics hook ---------- */
  let identifiedEmail = null;
  function track(event, props) {
    const payload = Object.assign({ popup: 'home_decor_scratch_oct2026' }, props || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'clp_' + event }, payload)); } catch(e){}
    try { if (identifiedEmail && window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Home Decor Popup: ' + event, payload); } catch(e){}
    if (CFG.trigger.demo) console.log('[popup]', event, payload);
  }

  /* ---------- state ---------- */
  function setState(s){
    pop.dataset.state = s;
    revealBtn.hidden = s !== 'scratch';
    chips.hidden = s !== 'revealed';
    if (s === 'scratch') status.innerHTML = '<strong>Scratch the sky</strong> to reveal your prayer corner';
    if (s === 'revealed') status.innerHTML = matchMedia('(hover:hover)').matches
      ? '<strong>Hover a piece</strong>, then click to see every design'
      : '<strong>Tap a piece</strong> to see every design';
  }

  /* ---------- hotspot geometry ---------- */
  stage.style.setProperty('--scene', 'url("' + (scene.currentSrc || scene.src) + '")');
  scene.addEventListener('load', () => stage.style.setProperty('--scene', 'url("' + scene.currentSrc + '")'));
  root.querySelectorAll('.clp-hs').forEach(el => {
    const r = CFG.hotspots[el.dataset.cat];
    el.style.left   = (r.x / SRC_W * 100) + '%';
    el.style.top    = (r.y / SRC_H * 100) + '%';
    el.style.width  = (r.w / SRC_W * 100) + '%';
    el.style.height = (r.h / SRC_H * 100) + '%';
    const img = el.querySelector('.clp-hs-img');
    img.style.backgroundSize = (SRC_W / r.w * 100) + '% ' + (SRC_H / r.h * 100) + '%';
    img.style.backgroundPosition = (r.x / (SRC_W - r.w) * 100) + '% ' + (r.y / (SRC_H - r.h) * 100) + '%';
  });

  // hover on hotspot ↔ highlight its label (and vice versa)
  function hot(cat, on){
    root.querySelectorAll('[data-cat="'+cat+'"]').forEach(n => n.classList.toggle('is-hot', on));
    stage.classList.toggle('has-hot', on && pop.dataset.state === 'revealed');
  }
  let hoverLogged = {};
  root.querySelectorAll('.clp-hs, .clp-label').forEach(el => {
    el.addEventListener('mouseenter', () => { hot(el.dataset.cat, true); if(!hoverLogged[el.dataset.cat]){hoverLogged[el.dataset.cat]=1; track('hotspot_hover',{category:el.dataset.cat}); prefetch(el.dataset.cat);} });
    el.addEventListener('mouseleave', () => hot(el.dataset.cat, false));
    el.addEventListener('click', () => openSheet(el.dataset.cat, el.classList.contains('clp-label') ? 'label' : 'hotspot'));
  });
  chips.querySelectorAll('button').forEach(b => b.addEventListener('click', () => openSheet(b.dataset.cat, 'chip')));

  /* =================== STEP 1: email gate → Klaviyo =================== */
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  async function subscribe(email){
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CFG.klaviyo.source,
          profile: { data: { type: 'profile', attributes: { email } } }
        },
        relationships: { list: { data: { type: 'list', id: CFG.klaviyo.listId } } }
      }
    };
    if (isDemoKlaviyo) {
      console.log('[popup] DEMO – would POST to Klaviyo:', body);
      await new Promise(r => setTimeout(r, 650));
      return { ok: true, demo: true };
    }
    const url = 'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(CFG.klaviyo.companyId);
    const send = () => fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': CFG.klaviyo.revision },
      body: JSON.stringify(body)
    });
    let res;
    try { res = await send(); }
    catch (e) { try { res = await send(); } catch (e2) { return { ok: false, network: true }; } }   // one retry on network error
    if (res.status === 202 || res.ok) return { ok: true };
    if (res.status >= 500) return { ok: false, network: true };
    return { ok: false, status: res.status };
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    errEl.textContent = '';
    if (!EMAIL_RE.test(email)) {
      errEl.textContent = email ? 'That email address looks incomplete. Check it and try again.' : 'Enter your email address to start revealing.';
      input.focus(); track('email_invalid'); return;
    }
    const btn = form.querySelector('button');
    btn.disabled = true; btn.textContent = 'Saving…';
    const r = await subscribe(email);
    btn.disabled = false; btn.textContent = 'Start revealing';

    if (!r.ok && !r.network) {               // Klaviyo rejected the address (4xx): ask the user to fix it
      errEl.textContent = 'We couldn’t save that address. Check it and try again.';
      track('email_rejected', { status: r.status }); return;
    }
    // Success, or Klaviyo unreachable after a retry: let the visitor continue rather than punish them.
    store.set(LS.sub, '1');
    identifiedEmail = email;
    try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email }); } catch(e){}
    track(r.ok ? 'email_submitted' : 'email_submit_failed_network', { demo: !!r.demo });
    startScratch();
  });

  /* =================== STEP 2: scratch =================== */
  const GX = 48, GY = 36;                    // coverage grid used to measure % scratched (cheaper than reading pixels)
  let cells = new Uint8Array(GX*GY), cleared = 0;
  let strokes = [], current = null, drawing = false, revealed = false, started = false, lastCheck = 0;

  function sizeCanvas(){
    const rect = stage.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    paintCover(rect.width, rect.height);
    strokes.forEach(s => replay(s, rect.width, rect.height));   // keep scratched areas after a resize
  }

  // Deterministic pseudo-random so the sky looks the same on every repaint
  function rng(seed){ return () => (seed = (seed * 16807) % 2147483647) / 2147483647; }
  function sparkle(x, y, r, a){
    ctx.save(); ctx.translate(x, y); ctx.globalAlpha = a;
    ctx.beginPath();
    ctx.moveTo(0,-r); ctx.quadraticCurveTo(r*.12,-r*.12, r,0); ctx.quadraticCurveTo(r*.12,r*.12, 0,r);
    ctx.quadraticCurveTo(-r*.12,r*.12, -r,0); ctx.quadraticCurveTo(-r*.12,-r*.12, 0,-r);
    ctx.fill(); ctx.restore();
  }
  function paintCover(w, h){
    ctx.globalCompositeOperation = 'source-over';
    const g = ctx.createLinearGradient(0, 0, 0, h);
    g.addColorStop(0, '#0b163a'); g.addColorStop(.55, '#132657'); g.addColorStop(1, '#0e1b44');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    const glow = ctx.createRadialGradient(w*.5, h*.36, 0, w*.5, h*.36, w*.42);
    glow.addColorStop(0, 'rgba(230,190,100,.30)'); glow.addColorStop(1, 'rgba(230,190,100,0)');
    ctx.fillStyle = glow; ctx.fillRect(0, 0, w, h);
    const rand = rng(7);
    ctx.fillStyle = '#f3dc9c';
    for (let i = 0; i < 170; i++) { ctx.globalAlpha = .25 + rand()*.6; ctx.beginPath(); ctx.arc(rand()*w, rand()*h, .4 + rand()*1.3, 0, Math.PI*2); ctx.fill(); }
    ctx.fillStyle = '#ffe9b0';
    for (let i = 0; i < 30; i++) { const x = rand()*w, y = rand()*h, s = 4 + rand()*(w/90), a = .55 + rand()*.4;
      if (x > w*.24 && x < w*.76 && y > h*.24 && y < h*.8) continue;   // keep the copy area calm
      sparkle(x, y, s, a); }
    ctx.globalAlpha = 1;
  }

  function brush(){ const w = stage.clientWidth; return Math.max(20, w * 0.045); }

  function markCells(nx, ny, nr){            // normalized coords
    const cx0 = Math.max(0, Math.floor((nx-nr)*GX)), cx1 = Math.min(GX-1, Math.floor((nx+nr)*GX));
    const cy0 = Math.max(0, Math.floor((ny-nr*4/3)*GY)), cy1 = Math.min(GY-1, Math.floor((ny+nr*4/3)*GY));
    for (let y = cy0; y <= cy1; y++) for (let x = cx0; x <= cx1; x++) {
      const dx = ((x+.5)/GX - nx), dy = ((y+.5)/GY - ny) * .75;
      if (dx*dx + dy*dy <= nr*nr && !cells[y*GX+x]) { cells[y*GX+x] = 1; cleared++; }
    }
  }
  function drawSeg(a, b, w, h){
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.lineWidth = a.r * w * 2;
    ctx.beginPath(); ctx.moveTo(a.x*w, a.y*h); ctx.lineTo(b.x*w, b.y*h); ctx.stroke();
    ctx.beginPath(); ctx.arc(b.x*w, b.y*h, a.r*w, 0, Math.PI*2); ctx.fill();
  }
  function replay(s, w, h){ for (let i = 1; i < s.length; i++) drawSeg(s[i-1], s[i], w, h); if (s.length===1) drawSeg(s[0], s[0], w, h); }

  function pointFromEvent(e){
    const rect = canvas.getBoundingClientRect();
    return { x: (e.clientX - rect.left)/rect.width, y: (e.clientY - rect.top)/rect.height, r: brush()/rect.width };
  }
  function addPoint(p){
    const w = stage.clientWidth, h = stage.clientHeight;
    const prev = current[current.length-1] || p;
    current.push(p);
    drawSeg(prev, p, w, h);
    const dist = Math.hypot(p.x-prev.x, p.y-prev.y), steps = Math.max(1, Math.ceil(dist / (p.r*.5)));
    for (let i = 1; i <= steps; i++) markCells(prev.x + (p.x-prev.x)*i/steps, prev.y + (p.y-prev.y)*i/steps, p.r);
    const now = performance.now();
    if (now - lastCheck > 60) { lastCheck = now; checkProgress(); }
  }
  function checkProgress(){
    const pct = cleared / (GX*GY);
    bar.style.width = Math.min(100, pct / CFG.revealThreshold * 100) + '%';
    if (!revealed && pct >= CFG.revealThreshold) reveal('scratch');
  }

  canvas.addEventListener('pointerdown', e => {
    if (pop.dataset.state !== 'scratch') return;
    drawing = true; canvas.setPointerCapture(e.pointerId);
    current = []; strokes.push(current);
    if (!started) { started = true; hint.classList.add('is-gone'); track('scratch_started'); }
    addPoint(pointFromEvent(e));
  });
  canvas.addEventListener('pointermove', e => { if (drawing) addPoint(pointFromEvent(e)); });
  ['pointerup','pointercancel','pointerleave'].forEach(t => canvas.addEventListener(t, () => { drawing = false; checkProgress(); }));

  function startScratch(){
    setState('scratch');
    prefetchAll();
  }

  function reveal(how){
    if (revealed) return;
    revealed = true; drawing = false;
    bar.style.width = '100%';
    pop.classList.add('just-revealed');
    setState('revealed');
    track('revealed', { method: how, scratched_pct: Math.round(cleared/(GX*GY)*100) });
    setTimeout(() => pop.classList.remove('just-revealed'), 5000);
  }
  revealBtn.addEventListener('click', () => reveal('button'));

  /* =================== STEP 3: product sheet =================== */
  const cache = {}, inflight = {};

  function priceStr(n){ return 'From $' + Number(n).toFixed(2); }
  function withUtm(url, cat){ return url + (url.includes('?') ? '&' : '?') + CFG.utm + '&utm_content=' + cat; }
  function placeholderImg(cat, name){
    const shape = cat === 'candle'
      ? '<path d="M70 150V78a30 34 0 0 1 60 0v72z" fill="#d8b25a" opacity=".85"/>'
      : cat === 'wooden'
        ? '<rect x="66" y="56" width="68" height="92" rx="3" fill="#8a5a33"/><rect x="72" y="62" width="56" height="80" fill="#d8b25a" opacity=".8"/>'
        : '<rect x="44" y="64" width="112" height="76" fill="#d8b25a" opacity=".85"/>';
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><rect width="200" height="200" fill="#16295c"/>' + shape + '</svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  function fallbackItems(cat){
    const c = CFG.categories[cat];
    const items = c.fallback.names.slice(0, CFG.productsPerCategory).map(n => ({
      title: n, price: c.fallback.price, image: placeholderImg(cat, n),
      url: CFG.storeUrl + '/search?type=product&q=' + encodeURIComponent(n), fallback: true,
      featured: !!c.featuredTitle && n.toLowerCase() === c.featuredTitle.toLowerCase()
    }));
    const i = items.findIndex(it => it.featured);
    if (i > 0) items.unshift(items.splice(i, 1)[0]);
    return items;
  }

  // Pull the live collection from Shopify so names, images, prices and links always match the site.
  async function loadCategory(cat){
    if (cache[cat]) return cache[cat];
    if (inflight[cat]) return inflight[cat];
    const c = CFG.categories[cat];
    inflight[cat] = (async () => {
      try {
        const res = await fetch(CFG.storeUrl + '/collections/' + c.handle + '/products.json?limit=24', { credentials: 'omit' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const seen = new Set();
        let items = (data.products || []).filter(p => {
          const key = p.title.trim().toLowerCase();        // the wooden-art collection currently lists some titles twice
          if (seen.has(key) || seen.has(p.handle)) return false;
          seen.add(key); seen.add(p.handle); return true;
        }).map(p => {
          const prices = (p.variants || []).map(v => parseFloat(v.price)).filter(n => !isNaN(n));
          const first = p.images && p.images[0] ? p.images[0] : null;
          const img = first ? first.src : null;
          return {
            title: p.title,
            price: prices.length ? Math.min.apply(null, prices) : null,
            image: img ? img + (img.includes('?') ? '&' : '?') + 'width=480' : placeholderImg(cat, p.title),
            url: CFG.storeUrl + '/products/' + p.handle,
            w: first && first.width, h: first && first.height
          };
        });
        if (c.featuredTitle) {
          const i = items.findIndex(it => it.title.toLowerCase() === c.featuredTitle.toLowerCase());
          if (i > 0) items.unshift(items.splice(i, 1)[0]);
          if (i >= 0) items[0].featured = true;
        }
        items = items.slice(0, CFG.productsPerCategory);
        if (!items.length) throw new Error('empty');
        cache[cat] = items;
      } catch (e) {
        if (CFG.trigger.demo) console.warn('[popup] live collection unavailable here (' + e.message + '), using fallback list for', cat);
        cache[cat] = fallbackItems(cat);
      }
      return cache[cat];
    })();
    return inflight[cat];
  }
  function prefetch(cat){ loadCategory(cat); }
  function prefetchAll(){ Object.keys(CFG.categories).forEach(prefetch); }

  // Use the most common photo ratio in the collection so the whole first image fits with no crop
  function ratioOf(items){
    const counts = {};
    items.forEach(it => { if (it.w && it.h) { const k = it.w + ' / ' + it.h; counts[k] = (counts[k] || 0) + 1; } });
    const best = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
    return best || null;
  }

  function renderSkeleton(){
    grid.innerHTML = Array.from({length: CFG.productsPerCategory}, () =>
      '<div class="clp-card clp-skel"><div class="clp-card-img"></div><div class="clp-card-name"></div></div>').join('');
  }
  function esc(s){ return String(s).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch])); }

  async function openSheet(cat, via){
    const c = CFG.categories[cat];
    sheetTitle.textContent = c.title;
    sheetSub.textContent = c.sub;
    viewAll.href = withUtm(CFG.storeUrl + '/collections/' + c.handle, cat);
    grid.style.setProperty('--card-ratio', c.imageRatio || (cache[cat] && ratioOf(cache[cat])) || '1 / 1');
    renderSkeleton();
    setState('sheet');
    hot(cat, false);
    track('category_opened', { category: cat, via });
    const items = await loadCategory(cat);
    if (pop.dataset.state !== 'sheet' || sheetTitle.textContent !== c.title) return;
    grid.style.setProperty('--card-ratio', c.imageRatio || ratioOf(items) || '1 / 1');
    grid.innerHTML = items.map((it, i) =>
      '<a class="clp-card" role="listitem" target="_top" href="' + esc(withUtm(it.url, cat)) + '" data-i="' + i + '">' +
        '<div class="clp-card-img"><img loading="lazy" alt="" src="' + esc(it.image) + '">' +
          (it.featured ? '<span class="clp-badge">In this corner</span>' : '') + '</div>' +
        '<div class="clp-card-name">' + esc(it.title) + '</div>' +
        (it.price != null ? '<div class="clp-card-price">' + priceStr(it.price) + '</div>' : '') +
      '</a>').join('');
    grid.querySelectorAll('img').forEach((img, i) => img.addEventListener('error', () => { img.src = placeholderImg(cat, items[i].title); }, { once: true }));
    grid.querySelectorAll('.clp-card').forEach(a => a.addEventListener('click', () =>
      track('product_clicked', { category: cat, product: items[+a.dataset.i].title, position: +a.dataset.i + 1 })));
    grid.scrollTop = 0;
  }
  root.querySelector('[data-back]').addEventListener('click', () => { stage.classList.remove('has-hot'); setState('revealed'); });

  /* =================== open / close / triggers =================== */
  let lastFocus = null;
  function open(reason){
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.style.display = 'flex';
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => { root.classList.add('is-open'); sizeCanvas(); });
    setTimeout(() => input.focus({ preventScroll: true }), 400);
    track('popup_viewed', { reason });
  }
  function close(){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(() => { root.style.display = ''; }, 350);
    if (!store.get(LS.sub)) store.set(LS.dis, String(Date.now()));
    track('popup_closed', { state: pop.dataset.state });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    if (pop.dataset.state === 'sheet') { stage.classList.remove('has-hot'); setState('revealed'); } else close();
  });
  window.addEventListener('resize', () => { if (root.classList.contains('is-open') && !revealed) sizeCanvas(); });

  function shouldShow(){
    if (CFG.trigger.demo) return true;
    if (store.get(LS.sub)) return false;
    const d = +store.get(LS.dis);
    return !(d && Date.now() - d < CFG.suppress.dismissDays * 864e5);
  }
  let armed = false;
  function arm(){
    if (armed) return; armed = true;
    if (!shouldShow()) return;
    if (CFG.trigger.demo) { open('demo'); return; }
    const t = setTimeout(() => open('delay'), CFG.trigger.delayMs);
    if (CFG.trigger.exitIntent && matchMedia('(hover:hover)').matches) {
      const onOut = e => { if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(t); document.removeEventListener('mouseout', onOut); open('exit_intent'); } };
      document.addEventListener('mouseout', onOut);
    }
  }

  function resetForDemo(){
    store.del(LS.sub); store.del(LS.dis);
    cells = new Uint8Array(GX*GY); cleared = 0; strokes = []; revealed = false; started = false;
    hint.classList.remove('is-gone'); bar.style.width = '0'; input.value = ''; errEl.textContent = ''; hoverLogged = {};
    setState('gate');
    if (root.classList.contains('is-open')) sizeCanvas(); else open('demo_replay');
  }
  const replayBtn = document.getElementById('demo-reset');
  if (replayBtn) replayBtn.addEventListener('click', resetForDemo);

  setState('gate');
  window.addEventListener('load', arm);
  if (document.readyState === 'complete') arm();
})();
